import React from "react";
import "./boxstyle.css"; // Ensure this file exists and is styled appropriately

function HowToBuySection() {
  const steps = [
    {
      number: "1",
      image: "1.png", // Replace with your actual image path or import
      title: "Wallet Connect",
      description: "Connect your crypto wallet (MetaMask or WalletConnect).",
    },
    {
      number: "2",
      image: "2.png",
      title: "Pay With Crypto",
      description: "Choose your amount and pay with ETH, USDT, BNB, USDC.",
    },
    {
      number: "3",
      image: "3.png",
      title: "Receive your $BABYU",
      description: "Receive your $BABYU after the presale ends.",
    },
  ];

  return (
    <div className="relative w-full h-auto overflow-x-hidden">
      {/* Background */}
      <div className="w-full min-h-screen sm:bg-[url('../public/Group88.png')] bg-no-repeat bg-center bg-[length:100%_100%]">
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;700;800&family=Inter:wght@400;500;600;700&display=swap"
        />

        <section className="overflow-hidden relative w-full min-h-screen flex justify-center items-center px-4">
          <div className="flex flex-col gap-16 max-w-[1344px] w-full items-start">
            {/* Header Section */}
            <header className="flex flex-col gap-6 justify-center items-start w-full max-w-3xl">
              <h1 className="text-7xl font-bold tracking-wider text-white leading-[72px] max-lg:text-6xl max-md:text-5xl max-sm:text-4xl max-sm:leading-snug">
                <span className="text-white font-fredoka">How to </span>
                <span className="font-fredoka text-6xl font-bold bg-clip-text max-lg:text-5xl max-md:text-4xl max-sm:text-3xl text-transparent bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
                  Buy
                </span>
              </h1>

              {/* SVG Gradient Title */}
           <div className="w-full max-w-[402px] sm:max-w-[320px] xs:max-w-[220px]">
  <svg
    viewBox="0 0 402 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="auto"
    className="w-full h-auto"
    preserveAspectRatio="xMinYMid meet"
  >
    <defs>
      <linearGradient id="paint0_linear_12_1641" x1="4.84729" y1="8.72222" x2="22.9163" y2="8.72222" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA8D1" />
        <stop offset="0.475962" stopColor="#C3B1FF" />
        <stop offset="1" stopColor="#AEE2FF" />
      </linearGradient>
      <linearGradient id="paint1_linear_12_1641" x1="108.325" y1="7.51852" x2="385.383" y2="7.51852" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA8D1" />
        <stop offset="0.475962" stopColor="#C3B1FF" />
        <stop offset="1" stopColor="#AEE2FF" />
      </linearGradient>
    </defs>
    <circle cx="12" cy="14.5" r="12" fill="url(#paint0_linear_12_1641)" />
    <circle cx="12" cy="14.5" r="6" fill="#4F416A" />
    <text
      fill="url(#paint1_linear_12_1641)"
      fontFamily="Inter"
      fontSize="24"
      fontWeight="500"
      x="34"
      y="23.2273"
    >
      3 EASY STEPS TO BUY $BABYU
    </text>
  </svg>
</div>


              <p className="text-xl text-neutral-100 leading-8 max-lg:text-lg max-md:text-base max-sm:text-sm max-sm:leading-relaxed">
                Buying $BABYU is simple and secure. Just connect your wallet,
                choose how much you want, and complete your purchase using ETH
                or USDT. Your tokens will be delivered to your wallet after the
                presale ends — it's that easy!
              </p>
            </header>

            {/* Steps Grid */}
            <div className="flex flex-col md:flex-row md:flex-wrap gap-6 w-full justify-start">
              {steps.map((step) => (
                <article
                  key={step.number}
                  className="flex frame-11 flex-col gap-4 p-6 rounded-xl border-2 border-solid backdrop-blur-[10px] bg-[#3a3350] bg-opacity-60 border-slate-800 border-opacity-10 w-full md:w-[432px]"
                >
                  <header className="flex justify-between items-center w-full">
                    <h2 className="text-3xl font-bold text-white max-lg:text-2xl max-md:text-xl max-sm:text-lg">
                      {step.title}
                    </h2>
                    <img
                      src={step.image}
                      alt={`Step ${step.number}`}
                      className="w-[60px] h-[60px] object-contain"
                    />
                  </header>
                  <p className="text-2xl text-neutral-100 leading-8 max-lg:text-xl max-md:text-base max-sm:text-sm max-sm:leading-relaxed">
                    {step.description}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default HowToBuySection;
